<template>
  <div id="app">
    <app-loading :visible="loading" />
    <app-dashboard v-if="!loading">
      <router-view slot="dash-content" />
    </app-dashboard>
    <app-notices />
  </div>
</template>

<script>
import AppDashboard from '@/components/ui/AppDashboard.vue'
import AppLoading from '@/components/ui/AppLoading.vue'
import Auth from '@/common/auth/index'
import HasLoading from '@/mixins/HasLoading.mixin'

export default {
  name: 'App',
  components: {
    AppDashboard,
    AppLoading
  },
  mixins: [
    HasLoading
  ],
  data () {
    return {
      loading: true
    }
  },
  created () {
    const token = Auth.GetToken()
    if (token && Auth.IsTokenExpired()) {
      Auth.CleanUpSession()
      Auth.GoToSso()
    }

    if (!token && this.$route.meta.requiresLogin) {
      Auth.GoToSso()
    } else {
      this.finishAppLoading()
    }
  }
}
</script>

<style lang="scss">
html, body {
  height: 100%;
  max-height: 100%;
}

#app {
  height: 100%;
  max-height: 100%;

  #loading-spinner {
    z-index: 100;
    position: absolute;
    top: 50%;
    left: 50%;
  }

  .app-centered-form {
    position: relative;

    form {
      margin: 0 auto;
      max-width: 700px;
      min-width: 300px;

      label.required::after {
        content: ' *';
      }
    }
  }

  .button-add-wrp {
    display: flex;
    justify-content: space-around;
    width: 20%;
    max-width: 180px;
    min-width: 70px;
  }

  .list-search-field {
    width: 250px;
    .input-content {
      max-width: 1300px;
      min-width: 260px;
    }
  }
  .toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue